import React from 'react';

function Support() {
  return (
    <div className="support-main" style={{ maxWidth: 1200, margin: '32px auto', padding: '0 16px' }}>
      <div className="support-card" style={{ 
        background: '#fff', 
        borderRadius: 8, 
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)', 
        padding: '24px 20px',
        marginBottom: 24
      }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: 16 }}>
          Need Help?
        </h2>
        <p style={{ fontSize: '1rem', lineHeight: 1.6, margin: 0 }}>
          For assistance, please contact our operations team at{' '}
          <a 
            href="mailto:Embarc@evicore.com" 
            style={{ color: '#009688', textDecoration: 'underline' }}
          >
            Embarc@evicore.com
          </a>
          . We&apos;re here to help!
        </p>
      </div>
    </div>
  );
}

export default Support;
